import React, { useEffect, useState } from "react";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { CreateFolder, GetFolder } from "../../../Redux/Slices/Folder";
import { Link } from "react-router-dom";
import { FaFolder, FaPlus, FaTimes } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const EmployerFolders = () => {
  const [data, setData] = useState("");
  const [folders, setFolders] = useState([]);
  const [showModal, setShowModal] = useState(false);

  //Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    let inputData = { name: data };
    await CreateFolder(inputData);
    handlefolder();
    setShowModal(false);
    setData("");
  };

  // Folder List
  const handlefolder = async () => {
    let data = await GetFolder();
    setFolders(data?.docs);
  };

  useEffect(() => {
    handlefolder();
    document.title = "My Folders | CAJobPortal";
  }, []);

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'My Folders']}>
        <div className="employer-page-header">
          <h1 className="employer-page-title">My Folders</h1>
          <button
            className="employer-btn employer-btn-primary"
            onClick={() => setShowModal(true)}
          >
            <FaPlus /> Add Folder
          </button>
        </div>

        <div className="employer-card">
          <div className="employer-table-container">
            <table className="employer-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Folder Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {folders?.length > 0 ? (
                  folders.map((item, index) => (
                    <tr key={item?._id}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="employer-flex employer-items-center employer-gap-2">
                          <FaFolder style={{ color: 'var(--employer-primary)' }} />
                          <span>{item?.name}</span>
                        </div>
                      </td>
                      <td>
                        <Link
                          to={`/employer/subfolders/${item?._id}`}
                          className="employer-btn employer-btn-sm employer-btn-ghost"
                        >
                          <FaFolder /> View Folder
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="employer-table-empty">
                      No folders available. Create your first folder to organize candidates.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="employer-modal-overlay" onClick={() => setShowModal(false)}>
            <div className="employer-modal" onClick={(e) => e.stopPropagation()}>
              <div className="employer-modal-header">
                <h3 className="employer-modal-title">Add New Folder</h3>
                <button
                  className="employer-modal-close"
                  onClick={() => setShowModal(false)}
                >
                  <FaTimes />
                </button>
              </div>
              <div className="employer-modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="employer-form-group">
                    <label className="employer-form-label required">Folder Name</label>
                    <input
                      onChange={(e) => setData(e.target.value)}
                      value={data}
                      type="text"
                      className="employer-form-input"
                      placeholder="Enter folder name"
                      required
                    />
                  </div>
                </form>
              </div>
              <div className="employer-modal-footer">
                <button
                  className="employer-btn employer-btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="employer-btn employer-btn-primary"
                  disabled={!data.trim()}
                >
                  <FaPlus /> Create Folder
                </button>
              </div>
            </div>
          </div>
        )}
      </EmployerLayout>
    </div>
  );
};

export default EmployerFolders;
